import { c as _c } from "react/compiler-runtime";
import { getImageProps } from "next/image";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { cn } from "@/lib/utils";
type CommentAvatarProps = {
  name: string;
  image?: string | null;
  className?: string;
};
const CommentAvatar = t0 => {
  const $ = _c(13);
  const {
    name,
    image,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("size-10", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== image || $[3] !== name) {
    t2 = image && <AvatarImage {...getImageProps({
      src: image,
      alt: `@${name}'s avatar`,
      width: 40,
      height: 40
    }).props} width={undefined} height={undefined} />;
    $[2] = image;
    $[3] = name;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== name) {
    t3 = name.charAt(0).toUpperCase();
    $[5] = name;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <AvatarFallback>{t3}</AvatarFallback>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t2 || $[11] !== t4) {
    t5 = <Avatar className={t1}>{t2}{t4}</Avatar>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
export { CommentAvatar };